/**
 * ConfirmationDialog - A component that displays a confirmation dialog with options to cancel or confirm an action.
 *
 * @interface ConfirmationDialogProps
 * - open: boolean - Determines if the dialog is currently visible
 * - onCancel: () => void - Function to call when the user cancels the dialog
 * - onConfirm: () => void - Function to call when the user confirms the action
 */

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

interface ConfirmationDialogProps {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  title?: string;
  description?: string;
  confirmText?: string;
  cancelText?: string;
}

export default function ConfirmationDialog({
  open,
  onCancel,
  onConfirm,
  title = "Confirm Action",
  description = "Are you sure you want to proceed?",
  confirmText = "Confirm",
  cancelText = "Cancel",
}: ConfirmationDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onCancel}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogTitle>{title}</DialogTitle>
        <DialogDescription>{description}</DialogDescription>
        <div className="mt-2 flex space-x-2">
          <Button onClick={onCancel}>{cancelText}</Button>
          <Button variant="destructive" onClick={onConfirm}>
            {confirmText}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
